import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './core-frontend-common/template/shared/layout/main/main.component';
import { UserProfileViewComponent } from './+app-custom/views/user-profile-view/user-profile-view.component';
import { AuthGuard } from './core-frontend-common/auth/guards/auth.guard';
import { DevComponent } from './+app-custom/components/dev/dev.component';
import { DashboardComponent } from './+app-custom/views/dashboard/dashboard.component';
import { EpcComponent } from './+app-custom/views/epc/epc.component';
import { EtdComponent } from './+app-custom/views/etd/etd.component';
import { IsbnComponent } from './+app-custom/views/isbn/isbn.component';
import { HelpdeskComponent } from './+app-custom/views/helpdesk/helpdesk.component';
import { RoombookComponent } from './+app-custom/views/roombook/roombook.component';
import { ZpComponent } from './+app-custom/views/zp/zp.component';
import { UikComponent } from './+app-custom/views/uik/uik.component';
import { OriginalityComponent } from './+app-custom/views/originality/originality.component';
import { OthersComponent } from './+app-custom/views/others/others.component';
import { NotificationsViewComponent } from './+app-custom/views/notifications-view/notifications-view.component';
import { ErrorReportsViewComponent } from './+app-custom/views/error-reports-view/error-reports-view.component';

const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full', canActivate: [AuthGuard] },
  {
    path: '',
    component: MainComponent,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dev', component: DevComponent, pathMatch: 'full' },
      { path: 'profile', component: UserProfileViewComponent, data: { pageTitle: 'profile' }, pathMatch: 'full' },
      { path: 'dashboard', component: DashboardComponent, data: { pageTitle: 'dashboard' }, pathMatch: 'full' },
      { path: 'epc', component: EpcComponent, data: { pageTitle: 'EPC' }, pathMatch: 'full' },
      { path: 'etd', component: EtdComponent, data: { pageTitle: 'ETD' } },
      { path: 'isbn', component: IsbnComponent, data: { pageTitle: 'ISBN' }, pathMatch: 'full' },
      { path: 'helpdesk', component: HelpdeskComponent, data: { pageTitle: 'HELPDESK' }, pathMatch: 'full' },
      { path: 'roombook', component: RoombookComponent, data: { pageTitle: 'ROOMBOOK' }, pathMatch: 'full' },
      { path: 'zp', component: ZpComponent, data: { pageTitle: 'ZP' }, pathMatch: 'full' },
      { path: 'uik', component: UikComponent, data: { pageTitle: 'UIK' }, pathMatch: 'full' },
      {
        path: 'originality', component: OriginalityComponent,
        data: { pageTitle: 'ORIGINALITY', roles: ['SUPERADMIN','UK_ADMIN'] }, pathMatch: 'full',
      },
      { path: 'others', component: OthersComponent, data: { pageTitle: 'OTHERS' }, pathMatch: 'full' },
      { path: 'notifications', component: NotificationsViewComponent, data: { pageTitle: 'NOTIFICATIONS' }, pathMatch: 'full' },
      { path: 'error-reports', component: ErrorReportsViewComponent, data: { pageTitle: 'ERRORS' }, pathMatch: 'full' },

    ],
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
